/* eslint-disable no-unused-vars */
import moment from 'moment';
import { mapActions, mapGetters, mapState } from 'vuex';
import socialLevelMixin from '@/mixins/socialLevel';
import accountVerifyMixin from '@/mixins/accountVerify';
import loaderMixin from '@/mixins/loader';
import accountSocialBadge from '@/components/account/account-social-badge/account-social-badge.vue';
import userAgentMixin from '@/mixins/userAgent';

moment.locale('en');
moment.updateLocale('en', {
  meridiem(hour, minute, isLowerCase) {
    return hour < 12 ? 'a.m.' : 'p.m.';
  },
});

export default {
  mixins: [
    accountVerifyMixin,
    loaderMixin,
    socialLevelMixin,
    userAgentMixin,
  ],
  components: {
    accountSocialBadge,
  },
  data() {
    const route = this.$router.currentRoute.name;
    return {
      name: null,
      accountBalance: null,
      portfolioBalance: null,
      currency: null,
      links: [
        { icon: 'wallet', name: 'Wallet', pathName: 'wallet', active: route === 'wallet' },
        { icon: 'history', name: 'History', pathName: 'account-history', active: route === 'account-history' },
        { icon: 'details', name: 'Account Details', pathName: 'account-details', active: route === 'account-details' },
        { icon: 'settings', name: 'Settings', pathName: 'account-settings', active: route === 'account-settings' },
        {
          icon: 'settings',
          name: 'Help And Support',
          pathName: 'HelpAndSupport',
          active: [
            'HelpAndSupport',
            'WhatIsPredictIt',
            'LearnTheBasics',
            'ComunityForums',
            'Faq',
            'Videos',
          ].includes(route),
        },
      ],
    };
  },
  metaInfo() {
    if (this.isLayoutMobile) {
      return {
        title: 'Account',
      };
    }
    return {};
  },
  computed: {
    ...mapState('wallet', ['balance']),
    ...mapGetters('app', ['hasMaintenanceMessage', 'isLayoutMobile']),
    cash() {
      return (Math.floor(this.balance.accountBalanceDecimal * 100) / 100).toFixed(2);
    },
  },
  methods: {
    ...mapActions('user', ['logout']),
    profileButtonClass(link) {
      return {
        profile__button: true,
        'profile__button--active': link.active,
      };
    },
    logoutButton() {
      this.loaderAdd(document.body);
      this.logout();
      this.$gtm.trackEvent({ event: 'Logout' });
    },
    isLinkAvailable(link) {
      if (link.pathName === 'wallet') {
        // return this.isUserVerified && !this.hasMaintenanceMessage;
        return this.isWalletEnabled;
      }
      return true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/profile/profile.js